// extracted by mini-css-extract-plugin
export default {"buttons":"GraphsSelector_buttons__5NGxg"};